



































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import WorkGroup from '../../../store/entities/sm/workgroups'
import CreateWorkGroupMember from './create-workgroup-member.vue'
import searchworkgroup from '@/store/entities/sm/searchworkgroup'
@Component({
  components: { CreateWorkGroupMember }
})
export default class CreateWorkLog extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  WorkGroupData: WorkGroup = new WorkGroup()
  createmember: boolean = false
  searchworkgroup: searchworkgroup = new searchworkgroup()
  logmembers: Array<any> = []
  oldrmemberlist: Array<any> = []
  usermemberdata: Array<any> = []
  get roles() {
    return this.$store.state.user.roles
  }
  save() {
    if (this.logmembers.length == 0) {
      this.$message({
        type: 'warning',
        message: '请至少选择一位组员'
      })
      return
    }
    let mempeoplr = ''
    for (let i = 0; i < this.logmembers.length; i++) {
      mempeoplr += this.logmembers[i].userId + ','
    }
    this.WorkGroupData.groupMember = mempeoplr
    ;(this.$refs.CreateWorkGroupForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: 'workgroup/CreateWorkGroup',
          data: this.WorkGroupData
        })
        this.logmembers = []
        ;(this.$refs.CreateWorkGroupForm as any).resetFields()
        this.$Message.success(this.L('SavedSuccess'))
        this.$emit('save-success')
        this.$emit('input', false)
      }
    })
  }
  //删除标签
  removeMember(index) {
    this.logmembers.splice(index, 1)
  }
  async addmember() {
    this.usermemberdata = []
    let oldrmemberlist = this.logmembers
    this.$store.commit('workgroup/setoldmemberlists', oldrmemberlist)
    this.$store.commit('workgroup/setWorkMemberUser', this.logmembers)
    this.createmember = true
    oldrmemberlist = []
  }
  async handleClose() {
    this.logmembers = this.$store.state.workgroup.memberlist
  }
  async handleCancel() {
    this.logmembers = this.$store.state.workgroup.oldmemberlist
  }
  cancel() {
    this.logmembers = []
    ;(this.$refs.CreateWorkGroupForm as any).resetFields()
    this.$emit('input', false)
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value)
    } else {
    }
  }
  workGroupRule = {
    groupName: [{ required: true, message: this.L('PleaseInput', undefined, this.L('WM.LogContent')), trigger: 'blur' }],
    groupRemark: [{ required: true, message: this.L('PleaseInput', undefined, this.L('WM.LogContent')), trigger: 'blur' }]
  }
}
